import { EditorPageStatePresenter } from '@/presentation/presenters/editor/editorPageStatePresenter'
import { EditorPageStateViewModel } from '@/presentation/viewmodels/editor/editorPageStateViewModel'

export function useEditorPageStatePresenter(
  presenter: EditorPageStatePresenter = new EditorPageStatePresenter(new EditorPageStateViewModel())
) {
  return {
    sourceCode: presenter.sourceCode,
    testFrameHeight: presenter.testFrameHeight,
    maxTestFrameHeight: presenter.maxTestFrameHeight,
    testPanelHeight: presenter.testPanelHeight,
    isFreeSpaceMode: presenter.isFreeSpaceMode,
    isErrorShow: presenter.isErrorShow,
    errorMessage: presenter.errorMessage,
    isPastingIOConsole: presenter.isPastingIOConsole,
    isHandlingTestFrame: presenter.isHandlingTestFrame,
    setSourceCode: presenter.setSourceCode.bind(presenter),
    setIsFreeSpaceMode: presenter.setIsFreeSpaceMode.bind(presenter),
    reverseIsFreeSpaceMode: presenter.reverseIsFreeSpaceMode.bind(presenter),
    setIsErrorShow: presenter.setIsErrorShow.bind(presenter),
    setIsPastingIOConsole: presenter.setIsPastingIOConsole.bind(presenter),
    updateMaxTestFrameHeight: presenter.updateMaxTestFrameHeight.bind(presenter),
    resizeTestFrameHeight: presenter.resizeTestFrameHeight.bind(presenter),
    mouseDownEditorBottomSlideBar: presenter.mouseDownEditorBottomSlideBar.bind(presenter),
    mouseUpEditorBottomSlideBar: presenter.mouseUpEditorBottomSlideBar.bind(presenter),
    downloadSourceCode: presenter.downloadSourceCode.bind(presenter),
    uploadSourceCode: presenter.uploadSourceCode.bind(presenter)
  }
}
